import React from 'react';

import { FormButtonProps } from 'app/components/common/buttons/form-button/form-button-props';
import { Button } from 'app/components/common/buttons/button/button';

type Props = FormButtonProps;

const SubmitButton: React.FC<Props> = (props: Props) => {
    const { submitting, loading, ...rest } = props;

    return (
        <Button type="primary" htmlType="submit" submitting={submitting} loading={loading || submitting} {...rest} />
    );
};

export { SubmitButton };
